import { RefreshCcw } from 'lucide-react';
import { useTravellerFeedback } from '../../../../context/travellerFeedback/TravellerFeedbackContext';
import { feedbackData } from '../../utils/feedbackHelpers';

const FeedbackHeader = () => {
  const { refreshAll, isLoading } = useTravellerFeedback();

  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
      <div>
        <h1 className="text-xl sm:text-2xl font-black text-[#067978] tracking-tight uppercase">
          {feedbackData.header.title}
        </h1>
        <p className="text-xs sm:text-sm text-slate-500 mt-1">
          {feedbackData.header.description}
        </p>
      </div>
      <button
        onClick={refreshAll}
        disabled={isLoading}
        className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 text-gray-700 rounded-xl hover:bg-gray-50 transition-colors text-sm font-medium shadow-xs disabled:opacity-60 cursor-pointer"
      >
        <RefreshCcw size={16} className={isLoading ? 'animate-spin' : ''} />
        Refresh
      </button>
    </div>
  );
};

export default FeedbackHeader;
